import {Component, computed, input, ChangeDetectionStrategy} from "@angular/core";
import {MetricComponentInputs} from "./metric";
import {LorenMetering} from "../loren-assets/interfaces/loren-metering.interface";
import {LorenAsset} from "../loren-assets/interfaces/loren-asset.interface";
import {LorenDateModule} from "../../shared/pipes/loren-date/loren-date.module";

@Component({
    template: `
        <img [src]="image()" alt="Image"/>
        <div class="overlay">
            <div class="description">
                <hr/>
                <div class="text">
                    <span>{{ metric().description }}</span>
                    <time>{{ metric().time | lorenDate }}</time>
                </div>
            </div>
        </div>
    `,

    styles: `
        :host {
            display: block;
            position: relative;
            flex: 1;
            width: 100%;
            max-height: 261px; /** This is hard-coded but would be better if it wasn't **/
            border-radius: var(--mat-card-elevated-container-shape, var(--mat-sys-corner-medium));
            overflow: hidden;

            /** TODO: Remove this and move to parent when all the metrics are migrated to the MetricConfig **/
            margin-bottom: 16px;
        }

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .overlay {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.2);
            color: white;
            padding: 8px;
        }

        time {
            text-transform: uppercase;
        }

        .description {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            padding: 16px;
            background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
        }

        hr {
            border: 1px solid #FFF;
            opacity: .5;
            margin: 8px 0;
        }
        
        .text {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        LorenDateModule
    ]
})
export class ImageSensorCard implements MetricComponentInputs {
    asset = input.required<LorenAsset>();
    metric = input.required<LorenMetering>();
    image = computed(() => this.metric().data.find(x => x.key === 'imageUrl')?.value)
}